import {
  NoResults,
  Pagination,
  SearchBox,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';
import { HitComponent, LoadingComponent } from '@white-nl/instantsearch-components/dist/types/components';
import { Hit, Loading } from '../components/search/results';
import Menu from '../components/refinements/Menu';

const settings = document.getElementById('search-overview')?.dataset || null;
const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
if (settings) {
  const apiUrl = Craft.getSiteUrl('api/react/search');

      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json())
        .then((data) => {
          const {
            translates,
            categoriesLabels,
            categoriesIcons,
            sectionsMapping,
          } = data;

          const {
            search,
            pagination,
          } = translates;

          const indexName = settings.indexName || '';

          whiteInstantSearchCatalog
            .withSearchkit(
              indexName,
              settings.publicUrl || '',
              settings.jwt || '',
              settings.refreshUrl || '',
            )
            .withWhiteInstantSearchRouting({
              baseUrl: settings.baseUrl,
              addToPath: true,
              addTrailingSlashesToUrls: Craft.trailingSlashes,
              pathAttribute: 'section',
              writeDelay: 0,
              mapping: { section: sectionsMapping },
            })
            .addAdditionalData({
              categoriesLabels,
              categoriesIcons,
              translates,
              showAllLabel: Craft.t(search, 'Show All'),
            })
            .addMenu(
              [{
                settings: {
                  attribute: 'section',
                  limit: 999,
                  sortBy: ['name:asc'],
                  classNames: {
                    root: 'md:p-2 md:bg-grey-100 md:rounded-full',
                    list: 'list-none flex flex-col md:flex-row gap-4 md:gap-8',
                    item: 'group/item',
                    selectedItem: 'selected',
                    link: 'min-w-64 px-6 py-3 rounded-full justify-start md:justify-center items-center text-grey-500 hover:text-green-300 hover:bg-light group-[.selected]/item:text-green-300 group-[.selected]/item:bg-light transition-all text-sm/4 text-md/4 font-bold no-underline flex gap-1',
                  },
                  isSearchable: false,
                  isClearable: true,
                  unstyled: true,
                },
                component: Menu,
              },
              ],
              '#white-instant-search-inline-menu',
            )
            .addSearchingComponent([
              {
                settings: {
                  placeholder: Craft.t(search, 'Search'),
                },
                component: SearchBox,
              },
            ])
            .addHitComponent(
              [
                {
                  settings: {
                    noResults: {
                      translations: {
                        noResults: Craft.t(search, 'Sorry, we can\'t find any content!'),
                        refinements: Craft.t(search, 'Try to choose another category or filter.'),
                        query: Craft.t(search, 'Please try another query.'),
                      },
                    },
                  },
                  component: Hit as HitComponent,
                  loadingComponent: Loading as LoadingComponent,
                  noResultsComponent: NoResults,
                },
              ],
              '#white-instant-search-hits',
            )
            .setHitsPerPage(8)
            .addPaginationComponent([
              {
                settings: {
                  classNames: {
                    noRefinementRoot: 'hidden',
                    list: 'list-none py-8 px-0 mx-0 my-auto w-full flex flex-wrap md:justify-between items-center gap-2 md:gap-4',
                    pageItem: 'group/item cursor-pointer p-0 size-8 md:size-10 flex justify-center items-center transition-all border border-gray-600 rounded-full text-gray-600 hover:bg-green-200 hover:border-green-200 [.active]:bg-green-200 [.active]:border-green-200',
                    link: 'block w-full text-center justify-start text-xs font-medium/4 line-clamp-1 no-underline',
                    previousPageItem: 'p-0 *:text-xs *:md:text-xs *:border-none mr-auto',
                    selectedItem: 'active',
                    disabledItem: '*:pointer-events-none *:text-grey-300',
                    nextPageItem: 'p-0 text-xs *:text-gray-600 ml-auto *:border-none',
                  },
                  translations: {
                    previousPageItemText: Craft.t(pagination, 'Previous'),
                    nextPageItemText: Craft.t(pagination, 'Next'),
                  },
                  showFirst: false,
                  showLast: false,
                },
                component: Pagination,
              }])
            .setScrolling({
              includeAttributes: ['page'],
            });
          whiteInstantSearchCatalog
            .build()
            .show();
        });
}
